import styled from "styled-components";

const ChoosePeriodModalButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 16px;
`;

const ChoosePeriodModalCancelButtonContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
`;

export default {
    ChoosePeriodModalButtonsContainer,
    ChoosePeriodModalCancelButtonContainer,
};
